
export type EntityKey = string;
export type EntityId = string;

export interface IDataModel {
    PartitionKey?: string;
    key?: EntityKey;
    typeName: Models;
    version: number
}

export enum Models {
    Base = "Base",
    UserProfile = "UserProfile",
    DailyEntry = "DailyEntry",
    DailyEntryList = "DailyEntryList",
    TextDataPoint = "TextDataPoint",
    SimpleText = "SimpleText",
    RecapEntry = "RecapEntry",
    TutorialState = "TutorialState",
    FeedbackRules = "FeedbackRules",
    FeedbackResponse = "FeedbackResponse",
}


export interface IResourceDescriptor { typeName: Models; id: string; }


export interface IQuote {
    /** The author of the quote */
    author: string;
    /** The text of the quote */
    text: string;
    /** Comma-separated list of words associated with the quote */
    tags?: string | undefined;
    /** A URL where the origin of the quote can be verified */
    source?: string | undefined;
}

export interface ITextDataPoint extends IDataModel {
    //
    // V0 - Text Data Point
    //
    text: string;
}